/* eslint-disable react/forbid-elements */
import * as React from 'react';
import { Image, UIHeading4, IconArrowRight16 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ICLusterOffer } from '../../../../types/cluster';

interface IOfferCardProps {
  offer: ICLusterOffer;
  onClick(offer: ICLusterOffer): void;
}

export function OfferCard({ offer, onClick }: IOfferCardProps) {
  return (
    <div className={styles['container']}>
      {offer.hasVideoMedia && (
        <div className={styles['video-icon-container']}>
          <div className={styles['video-icon']}>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38 20C38 29.9411 29.9411 38 20 38C10.0589 38 2 29.9411 2 20C2 10.0589 10.0589 2 20 2C29.9411 2 38 10.0589 38 20ZM40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM17.5547 13.0365L26.7519 19.1679C27.3457 19.5638 27.3457 20.4362 26.7519 20.8321L17.5547 26.9635C16.8901 27.4066 16 26.9302 16 26.1315L16 13.8685C16 13.0698 16.8901 12.5934 17.5547 13.0365Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      )}

      <div className={styles['image']}>
        <Image objectFit="cover" width="100%" height="100%" preloader src={offer.thumbnailUrl} />
      </div>

      <div className={styles['content']}>
        <div className={styles['title']}>
          <UIHeading4 color={'white_100'}>{offer.title}</UIHeading4>
        </div>
        <div className={styles['button']} onClick={() => onClick(offer)} data-testid="offer_card_button">
          <div className={styles['button-text']}>{offer.buttonTitle ?? 'Подробнее'}</div>
          <div className={styles['button-icon']}>
            <IconArrowRight16 color="white_100" />
          </div>
        </div>
      </div>
    </div>
  );
}
